import type { AmsProjectAudit } from '../../../services/amsProjectAuditService';

const auditIdOf = (audit: AmsProjectAudit): string => String(audit._id || (audit as any).id);

/**
 * Decides which audit should be selected when the approval drawer's audit
 * list (re)loads. Preserving the currently-selected audit across a refresh
 * always wins; otherwise an explicit initial audit (e.g. from a
 * summary-card click-through) is honored on first load only; the
 * fallback is the first active audit.
 */
export const resolveInitialAuditId = (
  activeAudits: AmsProjectAudit[],
  preserveAuditId: string | null | undefined,
  initialAuditId: string | null | undefined,
  initialAuditIdAlreadyApplied: boolean
): string | null => {
  if (activeAudits.length === 0) return null;

  if (preserveAuditId && activeAudits.some((a) => auditIdOf(a) === preserveAuditId)) {
    return preserveAuditId;
  }

  if (
    !initialAuditIdAlreadyApplied &&
    initialAuditId &&
    activeAudits.some((a) => auditIdOf(a) === initialAuditId)
  ) {
    return initialAuditId;
  }

  return auditIdOf(activeAudits[0]);
};
